import { i18n } from 'i18n';
import { IBadRequestAdditionalData } from 'shared/typings';

export const ERRORS = () => ({
	withdrawal_already_exists: () =>
		i18n.t(
			'У вас уже есть активный запрос на перевод. Чтобы заказать новый перевод, дождитесь завершения текущего запроса.',
		),
	withdrawal_is_not_possible: () => i18n.t('Withdrawal of funds is not possible.'),
	request_failed: (data?: IBadRequestAdditionalData) =>
		i18n.t('Не удается подключиться к {{url}}.', { url: data?.url }),
	unknown_error: () => i18n.t('Неизвестная ошибка.'),
	invalid_scheme: () => i18n.t('Невалидный URL. Поддерживается только HTTP/HTTPS.'),
	large_content: (data?: IBadRequestAdditionalData) =>
		i18n.t('Размер контента из {{url}} слишком большой.', { url: data?.url }),
	invalid_status_code: (data?: IBadRequestAdditionalData) =>
		i18n.t('Невалидный код статуса {{status}} из URL {{url}}.', { status: data?.status_code, url: data?.url }),
	encoding_error: () => i18n.t('Не удалось декодировать контент.'),
	content_not_matched: () => i18n.t('Контент верификации не найден.'),
	domain_is_restricted: (data?: IBadRequestAdditionalData) =>
		i18n.t('Площадка {{domain}} запрещена условиями сотрудничества', { domain: data?.domain }),
	domain_not_allowed: (data?: IBadRequestAdditionalData) =>
		i18n.t('Этот домен недоступен для сокращения. Доступные домены: {{domains}}', {
			domains: data?.allowed_domains?.join(', '),
		}),
	relation_already_added: (data?: IBadRequestAdditionalData) =>
		i18n.t('Площадки {{sources}} уже подключены к офферу', {
			sources: data?.sources_names?.join(', '),
		}),
	'Enter a valid URL.': () => i18n.t('Введите корректный URL.'),
	'Ensure this field has no more than 2048 characters.': () =>
		i18n.t('Количество символов не должно превышать {{characters}}', { characters: 2048 }),
	'Ensure this field has no more than 4096 characters.': () =>
		i18n.t('Количество символов не должно превышать {{characters}}', { characters: 4096 }),
	"URL must start with 'https://'.": () => i18n.t('URL должен начинаться с "https://"'),
	'You have already created the optimization code with the same source, offer, action_status and method.': () =>
		i18n.t('У вас уже создан postback с такими же площадкой, оффером, типом запроса и статусами действия'),
});
